module.exports = __webpack_public_path__ + "img/south-korea.42ea45ec.svg";